import { render, staticRenderFns } from "./BreakingNewsForm.vue?vue&type=template&id=13b892a7&"
import script from "./BreakingNewsForm.vue?vue&type=script&lang=js&"
export * from "./BreakingNewsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports